import(/* webpackMode: "eager" */ "/home/runner/work/canvasstaging/canvasstaging/src/app/global-error.tsx");
